<template>
  <div id="app">
    <ljb-loading
      v-if="isLoading"/>
    <div
      v-else
      class="base">
      <router-view/>
      <ljb-login/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import LjbLogin from '@/components/common/LjbLogin'

let isInited = false
export default {
  name: 'App',
  components: {LjbLogin},
  data () {
    return {
      isCheck: true
    }
  },
  computed: {
    ...mapGetters('Channel', ['getChannelData']),
    ...mapGetters('User', ['getUserInfo']),
    isLoading () {
      if (this.isCheck) {
        if (this.$utils.isEmpty(this.getChannelData)) return true
        if (this.$utils.getChannel() !== this.getChannelData.channelCode) {
          return true
        }
      }
      return false
    }
  },
  created () {
    this.$store.dispatch('Channel/getChannel')
    let urlParams = this.$utils.urlParams()
    if (urlParams && urlParams.token) {
      this.$store.dispatch('User/oAuthLogin', {authorizationToken: urlParams.token})
    }
    if (this.$utils.isWxgzh() && !isInited) {
      this.isCheck = false
      if (urlParams && urlParams.code) {
        this.$store.dispatch('User/requestOpenId', {code: urlParams.code, token: urlParams.token})
        this.isCheck = true
        return
      }
      let rou = location.hash
      if (rou) {
        rou = rou.replace('#', '')
      }
      location.href = this.$api.REDIRECT_OPENID + '?callback=' + decodeURIComponent(location.origin + location.pathname) + '&router=' + decodeURIComponent(rou)
      isInited = true
    }
  },
  mounted: function () {
    this.$utils.wxShare()
  },
  methods: {
    check () {
      this.isShowAlert = true
    }
  },
  watch: {
    $route(to) {
      this.$utils.updateShareData(to.path)
    }
  }
}
</script>

<style type="text/css" lang="scss">
  #app {
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    height: 100%;
    background: $background-color;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
    color: #ccc;
    font-size: 14px;
  }

  input:-moz-placeholder, textarea:-moz-placeholder {
    color: #ccc;
    font-size: 14px;
  }

  input::-moz-placeholder, textarea::-moz-placeholder {
    color: #ccc;
    font-size: 14px;
  }

  input:-ms-input-placeholder, textarea:-ms-input-placeholder {
    color: #ccc;
    font-size: 14px;
  }
  html,body,#app{

    height: 100%;

  }
  .base{
    overflow-x: hidden;
    overflow-y: scroll;
    width: 100%;
    height: 100%;
  }
  li{
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue